export function toRatingDate(value) {
  if (!value) return null;
  if (typeof value === 'object' && value.seconds != null) {
    const date = new Date(Number(value.seconds) * 1000);
    return Number.isNaN(date.getTime()) ? null : date;
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRatingDate(value, fallback = 'Date unavailable') {
  const date = toRatingDate(value);
  return date || fallback;
}
